/**
 * This custom hook provides the functionality to retrieve the course data.
 */

import {useContext} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useIntl} from "react-intl";
import {useSnackbar} from "notistack";

const useLoadSelectableUsersPlaylists = () => {

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving users selectable in the multi select
    const fetchSelectableUsers = async (courseAssociation) => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/courses/users/selectable?idToken=' + idToken + '&association=' + courseAssociation)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                return data.json();
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.courses.messages.load.selectableUsers.error',
                        defaultMessage: 'Something went wrong while loading the selectable users of the course: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
    }

    // Retrieving playlists selectable in the multi select
    const fetchSelectablePlaylists = async (courseAssociation) => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/courses/playlists/selectable?idToken=' + idToken + '&association=' + courseAssociation)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                return data.json();
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.courses.messages.load.selectablePlaylists.error',
                        defaultMessage: 'Something went wrong while loading the selectable playlists of the course: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
    }
    return {
        fetchSelectableUsers,
        fetchSelectablePlaylists
    }
}
export default useLoadSelectableUsersPlaylists;